'use client'

import {
  Carousel as CarouselMain,
  CarouselContent,
  CarouselItem as CarouselItemMain,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import Autoplay from "embla-carousel-autoplay"
import { Children } from "react"

/**
 * Renders a carousel component.
 *
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The content to be rendered inside the carousel.
 * @param {string} [props.className] - The additional CSS class name for the carousel.
 * @param {boolean} [props.autoPlay=false] - Determines if the carousel should automatically play.
 * @param {number} [props.delay=3000] - The delay in milliseconds between each slide transition.
 * @param {string} [props.orientation='horizontal'] - The orientation of the carousel ('horizontal' or 'vertical').
 * @returns {JSX.Element} The rendered carousel component.
 */

interface CarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  autoPlay?: boolean
  delay?: number
  orientation?: 'horizontal' | 'vertical'
  opts?: any
}

export function Carousel({ children, className, autoPlay = false, delay = 3000 , orientation = 'horizontal', opts, ...props }: CarouselProps) {
  // const [api, setApi] = useState<any>(undefined)
  // const [current, setCurrent] = useState(0)
  // const [count, setCount] = useState(0)

  // useEffect(() => {
  //   if (!api) return
    
  //   setCount(api.scrollSnapList().length)
  //   setCurrent(api.selectedScrollSnap() + 1)
     
  //   api.on("select", () => {
  //     setCurrent(api.selectedScrollSnap() + 1)
  //   })
  // }, [api])

  return (
    <CarouselMain orientation={orientation} className={`group relative w-full max-w-xs ${className}`} opts={{ loop: true, ...opts }} plugins={ autoPlay ? [ Autoplay({ delay: delay }) ] : undefined } {...props}>
      <CarouselContent>
        { children }
      </CarouselContent>
      {Children.count(children) > 1 && (
        <>
          <CarouselPrevious className="left-3 sm:left-4 top-1/2 bottom-auto -translate-y-1/2 size-9 sm:size-11 rounded-full border-0 bg-white/70 hover:bg-white text-foreground backdrop-blur-md shadow-lg shadow-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex!" />
          <CarouselNext className="right-3 sm:right-4 top-1/2 bottom-auto -translate-y-1/2 size-9 sm:size-11 rounded-full border-0 bg-white/70 hover:bg-white text-foreground backdrop-blur-md shadow-lg shadow-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex!" />
        </>
      )}
    </CarouselMain>
  )
}

export const CarouselItem = CarouselItemMain